var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCaseStudiesNav = function SvgCaseStudiesNav(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.15674,
    width: 11,
    height: 11,
    rx: 2,
    fill: "#78786D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17.1567,
    width: 11,
    height: 13,
    rx: 2,
    fill: "#78786D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3 27.6567H15",
    stroke: "#78786D",
    strokeLinecap: "square",
    strokeDasharray: "1 1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.15674,
    width: 23,
    height: 20,
    rx: 2,
    fill: "#F5F4EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3 21.6567H15",
    stroke: "#78786D",
    strokeLinecap: "square",
    strokeDasharray: "1 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3 18.6567H15",
    stroke: "#78786D",
    strokeLinecap: "square",
    strokeDasharray: "1 1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3 15.6567H15",
    stroke: "#78786D",
    strokeLinecap: "square",
    strokeDasharray: "1 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3 24.6567H15",
    stroke: "#78786D",
    strokeLinecap: "square",
    strokeDasharray: "1 1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5467 16.6548C26.7955 17.8825 26.3998 19.2832 26.3998 20.702C26.3998 20.9521 26.1998 21.1567 25.9553 21.1567H23.4661C23.2217 21.1567 23.0217 20.9521 23.0217 20.702V19.6971C23.0217 19.5152 22.9728 19.3878 22.9283 19.3515C22.9194 19.3423 22.8972 19.3288 22.8215 19.3423L22.4037 19.4288C22.0392 19.506 21.6614 19.4059 21.368 19.1604C21.0614 18.9057 20.8881 18.5283 20.8881 18.1191V17.9372H20.4436C20.2968 17.9372 20.1592 17.8599 20.0792 17.7371C19.9947 17.6144 19.9769 17.4598 20.0303 17.3188L20.4081 16.2956C20.5549 15.909 20.6081 15.4953 20.6704 15.0586C20.7058 14.7903 20.7413 14.5128 20.7991 14.2309C21.1681 12.4847 22.5726 11.2159 24.2218 11.1567H24.3418C25.2754 11.1567 26.1553 11.5115 26.8354 12.1845C27.5777 12.9167 28 13.9489 28 15.0176C28 15.5998 27.8445 16.1635 27.5467 16.6548Z",
    fill: "#78786D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCaseStudiesNav);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNSAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMy4xNTY3NCIgd2lkdGg9IjExIiBoZWlnaHQ9IjExIiByeD0iMiIgZmlsbD0iIzc4Nzg2RCIvPgo8cmVjdCB4PSIyMSIgeT0iMTcuMTU2NyIgd2lkdGg9IjExIiBoZWlnaHQ9IjEzIiByeD0iMiIgZmlsbD0iIzc4Nzg2RCIvPgo8cGF0aCBvcGFjaXR5PSIwLjQiIGQ9Ik0zIDI3LjY1NjdIMTUiIHN0cm9rZT0iIzc4Nzg2RCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxyZWN0IHg9IjciIHk9IjYuMTU2NzQiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMCIgcng9IjIiIGZpbGw9IiNGNUY0RUIiLz4KPHBhdGggb3BhY2l0eT0iMC40IiBkPSJNMyAyMS42NTY3SDE1IiBzdHJva2U9IiM3ODc4NkQiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1kYXNoYXJyYXk9IjEgMSIvPgo8cGF0aCBvcGFjaXR5PSIwLjQiIGQ9Ik0zIDE4LjY1NjdIMTUiIHN0cm9rZT0iIzc4Nzg2RCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxwYXRoIG9wYWNpdHk9IjAuNCIgZD0iTTMgMTUuNjU2N0gxNSIgc3Ryb2tlPSIjNzg3ODZEIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtZGFzaGFycmF5PSIxIDEiLz4KPHBhdGggb3BhY2l0eT0iMC40IiBkPSJNMyAyNC42NTY3SDE1IiBzdHJva2U9IiM3ODc4NkQiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1kYXNoYXJyYXk9IjEgMSIvPgo8cGF0aCBkPSJNMjcuNTQ2NyAxNi42NTQ4QzI2Ljc5NTUgMTcuODgyNSAyNi4zOTk4IDE5LjI4MzIgMjYuMzk5OCAyMC43MDJDMjYuMzk5OCAyMC45NTIxIDI2LjE5OTggMjEuMTU2NyAyNS45NTUzIDIxLjE1NjdIMjMuNDY2MUMyMy4yMjE3IDIxLjE1NjcgMjMuMDIxNyAyMC45NTIxIDIzLjAyMTcgMjAuNzAyVjE5LjY5NzFDMjMuMDIxNyAxOS41MTUyIDIyLjk3MjggMTkuMzg3OCAyMi45MjgzIDE5LjM1MTVDMjIuOTE5NCAxOS4zNDIzIDIyLjg5NzIgMTkuMzI4OCAyMi44MjE1IDE5LjM0MjNMMjIuNDAzNyAxOS40Mjg4QzIyLjAzOTIgMTkuNTA2IDIxLjY2MTQgMTkuNDA1OSAyMS4zNjggMTkuMTYwNEMyMS4wNjE0IDE4LjkwNTcgMjAuODg4MSAxOC41MjgzIDIwLjg4ODEgMTguMTE5MVYxNy45MzcySDIwLjQ0MzZDMjAuMjk2OCAxNy45MzcyIDIwLjE1OTIgMTcuODU5OSAyMC4wNzkyIDE3LjczNzFDMTkuOTk0NyAxNy42MTQ0IDE5Ljk3NjkgMTcuNDU5OCAyMC4wMzAzIDE3LjMxODhMMjAuNDA4MSAxNi4yOTU2QzIwLjU1NDkgMTUuOTA5IDIwLjYwODEgMTUuNDk1MyAyMC42NzA0IDE1LjA1ODZDMjAuNzA1OCAxNC43OTAzIDIwLjc0MTMgMTQuNTEyOCAyMC43OTkxIDE0LjIzMDlDMjEuMTY4MSAxMi40ODQ3IDIyLjU3MjYgMTEuMjE1OSAyNC4yMjE4IDExLjE1NjdIMjQuMzQxOEMyNS4yNzU0IDExLjE1NjcgMjYuMTU1MyAxMS41MTE1IDI2LjgzNTQgMTIuMTg0NUMyNy41Nzc3IDEyLjkxNjcgMjggMTMuOTQ4OSAyOCAxNS4wMTc2QzI4IDE1LjU5OTggMjcuODQ0NSAxNi4xNjM1IDI3LjU0NjcgMTYuNjU0OFoiIGZpbGw9IiM3ODc4NkQiLz4KPC9zdmc+Cg==";